/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI BMAW
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StringReferenceReadModel
 */
export interface StringReferenceReadModel {
    /**
     * 
     * @type {string}
     * @memberof StringReferenceReadModel
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StringReferenceReadModel
     */
    displayName: string;
}

/**
 * Check if a given object implements the StringReferenceReadModel interface.
 */
export function instanceOfStringReferenceReadModel(value: object): value is StringReferenceReadModel {
    if (!('displayName' in value) || value['displayName'] === undefined) return false;
    return true;
}

export function StringReferenceReadModelFromJSON(json: any): StringReferenceReadModel {
    return StringReferenceReadModelFromJSONTyped(json, false);
}

export function StringReferenceReadModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): StringReferenceReadModel {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'displayName': json['displayName'],
    };
}

export function StringReferenceReadModelToJSON(json: any): StringReferenceReadModel {
    return StringReferenceReadModelToJSONTyped(json, false);
}

export function StringReferenceReadModelToJSONTyped(value?: StringReferenceReadModel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'displayName': value['displayName'],
    };
}

